import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  directoryApi,
  type CreateAccountRequest,
  type CreateAccountResponse,
} from '../client';
import { useSupportAccounts } from './useSupportAccounts';

/**
 * Onboard a customer account.
 *
 * <p>
 * Invalidates the support-account list on success — the new account has to
 * appear in the picker immediately, or the first thing you do after creating
 * one is reload to find it.
 * </p>
 */
export function useCreateAccount() {
  const queryClient = useQueryClient();

  return useMutation<CreateAccountResponse, Error, CreateAccountRequest>({
    mutationFn: (body) => directoryApi.createAccount(body),
    // RETURNED, not fired and forgotten. React Query keeps the mutation
    // pending until this resolves, so by the time the caller navigates the
    // account list already contains the new row. Without it the strip can
    // render from the old list while the page renders from the new one — the
    // account selected everywhere except in the picker.
    onSuccess: () => queryClient.invalidateQueries({ queryKey: useSupportAccounts.queryKey }),
  });
}
